import { useCampaign } from '@tm/client-form/src/hooks/useCampaign'
import { useReplaceSegmentParameters } from '@tm/client-form/src/hooks/useReplaceSegmentParameters'
import { ThirdPartyCollectSource } from '@tm/types/survey/third-party-collect'
import { useEffect, useState } from 'react'

const redirectDelaySeconds = 5

export const usePlatformRedirect = (sources?: ThirdPartyCollectSource[] | null, noRedirect?: boolean) => {
  const { campaignFrame } = useCampaign()
  /** -1 = countdown not yet started */
  const [redirectCountdownSeconds, setRedirectCountdownSeconds] = useState(-1)
  const redirectSource = (sources?.length === 1 && sources[0].source !== 'Trustmary' && sources[0]) || null

  const redirectUrl = useReplaceSegmentParameters(redirectSource?.url || '')

  useEffect(() => {
    if (!redirectUrl || noRedirect) {
      return
    }

    if (redirectCountdownSeconds >= 0) return

    setTimeout(() => {
      if (campaignFrame.inFrame) {
        window.open(redirectUrl, '_blank')
        return
      }

      window.location.href = redirectUrl
    }, redirectDelaySeconds * 1000)

    setRedirectCountdownSeconds(redirectDelaySeconds)

    setInterval(() => {
      setRedirectCountdownSeconds(seconds => Math.max(0, seconds - 1))
    }, 1000)
  }, [redirectUrl, noRedirect, campaignFrame, redirectCountdownSeconds])

  return {
    isRedirecting: !!redirectUrl && !noRedirect,
    redirectUrl,
    redirectCountdownSeconds,
    redirectSource,
  }
}
